<h1 mat-dialog-title>Ustawianie dostępności - {{ product?.name }}</h1>
<div mat-dialog-content>
	<mat-form-field class="full">
		<mat-label>Typ akcji</mat-label>
		<mat-select [(ngModel)]="data.action">
			<mat-option value="setavl">Ustaw dostępność</mat-option>
			<mat-option value="delavl">Usuń dostępność</mat-option>
			<mat-option value="lcksel">
				Blokada sprzedaży (wykorzystane przez Właściciela, nie liczy do wykorzystania)
			</mat-option>
			<mat-option value="lckavl">
				Blokada dostępności (wykorzystane przez Oskar, liczone do wykorzystania)
			</mat-option>
			<mat-option value="delsta">Usuń blokade</mat-option>
		</mat-select>
	</mat-form-field>

	<fieldset *ngIf="data.action">
		<app-select-multi
			[options]="product.rooms"
			[(selected)]="data.room"
			(blured)="roomChanged()"
			labelKey="roomNumber"
			placeholder="Wybierz pokoje"
		></app-select-multi>

		<mat-checkbox [(ngModel)]="data.roomSlavesRemove" *ngIf="data.action === SetAvailabilityAction.DELETE">
			Usuń dostępność <b>tylko</b> dla pokoi podrzędnych
		</mat-checkbox>

		<app-select-multi
			[options]="roomSlaves"
			[(selected)]="data.roomSlave"
			placeholder="Pokoje podrzędne"
			*ngIf="data.roomSlavesRemove === true || !['lcksel', 'lckavl', 'delsta'].includes(data.action)"
		></app-select-multi>

		<div class="grouped-form-fields mt-3">
			<mat-form-field>
				<input
					matInput
					type="date"
					name="lower"
					onfocus="this.showPicker()"
					[(ngModel)]="data.dateRange.lower"
					[ngClass]="{
						error: !error.dateRange && !data.dateRange.lower,
					}"
					class="form-control"
					placeholder="Zakres dat"
				/>
			</mat-form-field>
			<mat-form-field>
				<input
					matInput
					type="date"
					name="upper"
					onfocus="this.showPicker()"
					[(ngModel)]="data.dateRange.upper"
					[ngClass]="{
						error: !error.dateRange && !data.dateRange.upper,
					}"
					class="form-control"
				/>
			</mat-form-field>
		</div>
	</fieldset>
	<fieldset *ngIf="data.action === SetAvailabilityAction.SET">
		<mat-form-field class="full">
			<mat-select
				placeholder="Rodzaj dostępności"
				[(ngModel)]="data.availabilityType"
				[ngClass]="{
					error: !error.availabilityType && !data.availabilityType,
				}"
				class="mt-3"
			>
				<mat-option *ngFor="let item of availabilityType" [value]="item.id">
					{{ item.name }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<div class="grouped-form-fields mt-3">
			<mat-form-field>
				<input
					matInput
					type="number"
					name="cost"
					[(ngModel)]="data.cost"
					[ngClass]="{ error: !error.cost && !data.cost }"
					class="form-control"
					placeholder="Koszt pokoju / dzień"
					required
				/>
			</mat-form-field>
			<mat-form-field>
				<mat-select
					placeholder="Waluta"
					[(ngModel)]="data.currency"
					[ngClass]="{
						error: !error.currency && !data.currency,
					}"
				>
					<mat-option *ngFor="let item of currency" [value]="item.id">
						{{ item.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</fieldset>
	<fieldset *ngIf="['lckavl', 'lcksel'].includes(data.action)">
		<mat-form-field class="full">
			<input matInput placeholder="Komentarz" name="comment" [(ngModel)]="data.comment" class="mt-3" />
		</mat-form-field>
	</fieldset>
</div>
<div mat-dialog-actions class="mt-3">
	<button mat-button mat-dialog-close>Anuluj</button>
	<div class="spacer"></div>
	<ng-container *ngIf="data.action">
		<button type="button" *ngIf="data.action === SetAvailabilityAction.SET" class="btn btn-primary" (click)="set()">
			Ustaw dostępność
		</button>
		<button
			type="button"
			*ngIf="data.action === SetAvailabilityAction.DELETE"
			class="btn btn-danger"
			(click)="set()"
		>
			Usuń dostępność
		</button>
		<button
			type="button"
			*ngIf="data.action === SetAvailabilityAction.LOCK_AVAILABILITY"
			class="btn btn-warning"
			(click)="set()"
		>
			Zablokuj dostępność (wykorzystane przez Oskar, liczone do wykorzystania)
		</button>
		<button
			type="button"
			*ngIf="data.action === SetAvailabilityAction.LOCK_SELL"
			class="btn btn-warning"
			(click)="set()"
		>
			Zablokuj sprzedaż (wykorzystane przez Właściciela, nie liczy do wykorzystania)
		</button>
		<button
			type="button"
			*ngIf="data.action === SetAvailabilityAction.REMOVE_BLOCKADS"
			class="btn btn-warning"
			(click)="set()"
		>
			Usuń blokazdy
		</button>
	</ng-container>
</div>
